import React from 'react';
import { Mode } from '../../../../utils';
import { mergeDeep } from '../../../../utils/Helper';
import { CustodyLock, CustodyIntStatus } from '../../../Custody/types';

export const initialize = (props) => {
	return (initialState) => {
    let state = mergeDeep(
      {...initialState},
      {
        ui: {
          mode: props.mode || Mode.EDIT,
          loading: props.retriveAsync
        },
        custody: {
          ...props.custody,
          actualstatus: props.custody.internalstatus
        } 
      }
    );

    if (state.ui.mode == Mode.READONLY) {
      Object.keys(state.custody).forEach(f => {
        state.fields.readonly[f] = true;
      })

      state.buttons.precheck.readonly = true;
    }

    return state;
  }
}

export const defaultState = () => ({
  event:{
    id: 0,
    CorporateEventType: "",
    Date: "0000-00-00",
    name: "",
    CurrencyId: "0",
    CurrencyISO: "",
    "AssetId": "0",
    "AssetName": "",
    "AssetTicker": "",
    "CorporateEventSplitFrom": 0,
    "CorporateEventSplitTo": 0,
    "CorporateEventExDividendDate": "0000-00-00",
    "Status": "",
    "CorporateEventSettlementCurrency": 0,
    "CorporateEventCommissionCurrency": 0,
    "CorporateEventFX": 0.00000000,
    "CorporateEventCommissionFX": 0.00000000,
    "CorporateEventTaxCurrency": 0,
    "CorporateEventTaxFX": 0.00000000,
    "CorporateEventIsCovered": false,
    "CorporateEventIsCoverable": false,
    Account : [
      {
      "BasicAccountId": "0",
      "BasicAccountName": "",
      "EventBalanceType": "",
      "EventAccountAmount": "0.0000",
    Footprint : [{
            "EventAccountFootprintId": "0",
            "EventAccountDebitCredit": 0,
            "EventAccountDebitCreditVolume": "0.00000000",
            "EventAccountIsCurrency": false,
            "EventAccountSecurityId": "0",
            "EventAccountTicker": "",
            "EventAccountIsCommission": false,
            "EventAccountIsTax": false,
            "EventAccountIsWithholding": false
    }]
  }
    ]
  },
})